import { useEffect, useState } from 'react';
import { useT } from 'i18n';
import { fechaCorta, money, num } from '../../mercado/utils';
import '../../mercado/mis.css';

const ATAJOS = [25, 50, 75, 100];
const FECHAS = [
  { id: '1', tk: 'inv.fHoy' },
  { id: '2', tk: 'inv.fElegir' },
  { id: '3', tk: 'inv.fSin' },
];

const InvestmentModal = ({ open, investment, onClose, onSubmit, isSubmitting, saleResult }) => {
  const { t, ts } = useT();
  const [pct, setPct] = useState('');
  const [dateType, setDateType] = useState('3');
  const [dateValue, setDateValue] = useState('');

  useEffect(() => {
    if (open) { setPct(''); setDateType('3'); setDateValue(''); }
  }, [open, investment && investment.id]);

  useEffect(() => {
    if (!open) return undefined;
    const tecla = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', tecla);
    return () => window.removeEventListener('keydown', tecla);
  }, [open, onClose]);

  if (!open || !investment) return null;

  const invertido = num(investment.investment_amount);
  const rend = num(investment.rendimiento);
  const p = Math.min(100, Math.max(0, num(pct)));
  const precio = (p * (invertido + rend)) / 100;
  const hoy = new Date().toISOString().slice(0, 10);
  const listo = p > 0 && (dateType !== '2' || dateValue);
  const exito = saleResult && saleResult.success;

  const enviar = (e) => {
    e.preventDefault();
    if (!listo) return;
    onSubmit({
      investment_id: investment.id,
      amount_percentage: String(p),
      date_type: dateType,
      date_value: dateType === '2' ? dateValue : '',
      rendimiento: investment.rendimiento,
    });
  };

  return (
    <div className="p7x-overlay" role="dialog" aria-modal="true" aria-label={t('inv.modalAria')} onClick={onClose}>
      <form className="p7x-modal" onClick={(e) => e.stopPropagation()} onSubmit={enviar}>
        <button type="button" className="p7m-cerrar" onClick={onClose} aria-label={t('panel.cerrar')}>×</button>

        <header className="p7x-modal-head">
          {investment.imagen ? <img src={investment.imagen} alt="" /> : null}
          <div>
            <h2>{t('inv.ponerVenta')}</h2>
            <p>{investment.name}</p>
          </div>
        </header>

        <dl className="p7x-datos p7x-datos-4">
          <div><dt>{t('inv.kpiInvertido')}</dt><dd>${money(invertido)}</dd></div>
          <div><dt>{t('inv.rendimiento')}</dt><dd className="verde">+${money(rend)}</dd></div>
          <div><dt>{t('inv.invertisteEl')}</dt><dd>{fechaCorta(investment.date_investment)}</dd></div>
          <div><dt>{t('inv.cierraEl')}</dt><dd>{fechaCorta(investment.end_date)}</dd></div>
        </dl>

        <label className="p7x-lbl" htmlFor="p7x-pct">{t('inv.queParte')}</label>
        <div className="p7x-pct">
          <input className="p7x-in" id="p7x-pct" type="number" min="1" max="100" step="0.01" inputMode="decimal" value={pct} onChange={(e) => setPct(e.target.value)} placeholder="0" required />
          <span>%</span>
        </div>
        <div className="p7x-atajos">
          {ATAJOS.map((a) => (
            <button type="button" key={a} className={num(pct) === a ? 'on' : ''} onClick={() => setPct(String(a))}>{a}%</button>
          ))}
        </div>

        <span className="p7x-lbl">{t('inv.hastaCuando')}</span>
        <div className="p7-seg p7x-fechas" role="group" aria-label={t('inv.vigencia')}>
          {FECHAS.map((f) => (
            <button type="button" key={f.id} className={dateType === f.id ? 'on' : ''} onClick={() => setDateType(f.id)}>{t(f.tk)}</button>
          ))}
        </div>
        {dateType === '2' && (
          <input className="p7x-fecha" type="date" min={hoy} value={dateValue} onChange={(e) => setDateValue(e.target.value)} required aria-label={t('inv.fechaLimite')} />
        )}

        <div className="p7x-total">
          <span>{t('inv.recibiras')}</span>
          <strong>${money(precio)} <small>USDT</small></strong>
        </div>

        {saleResult && <div className={`p7x-aviso${exito ? '' : ' err'}`} role="status">{ts(saleResult.message)}</div>}

        <div className="p7-wallet-actions" style={{ marginTop: '.4rem' }}>
          <button type="button" className="p7-btn-ghost" onClick={onClose}>{exito ? t('panel.cerrar') : t('inv.cancelar')}</button>
          <button type="submit" className="p7-btn-gold" disabled={isSubmitting || !listo || exito}>{isSubmitting ? t('inv.publicando') : t('inv.publicar')}</button>
        </div>
      </form>
    </div>
  );
};

export default InvestmentModal;
